// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__f5IY_"};